import React, { useState, useEffect } from "react";
import ChatBot from "@/Components/ChatBot/ChatBot.jsx";
import { Head } from "@inertiajs/react";
import Header from "@/Components/Header.jsx";
import Footer from "@/Components/Footer.jsx";
import { useLaravelReactI18n } from "laravel-react-i18n";
import Breadcrumbs from "@/Components/Breadcrumbs.jsx";
import Button from '@/Components/UI/Button';

import casesPointsPicture from '../../images/pages/cases/cases-points.png';
import DecorBlob from "@/Components/Decor/DecorBlob.jsx";
import DecorContainer from "@/Components/Decor/DecorContainer.jsx";
import CaseBlock from "@/Components/CaseBlock.jsx";

export default function Cases(pageProps) {
    const { t } = useLaravelReactI18n();

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoaded(true);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <ChatBot
                csrf_token={pageProps.csrf_token}
                user_id={pageProps.user_id}
                is_admin={pageProps.is_admin}
            ></ChatBot>

            <Head>
                <title>{t("site.casePage.pageTitle")}</title>
                <meta name="title" content={t("site.casePage.pageTitle")} />
                <meta name="description" content={t("site.casePage.pageDescription")} />

                <meta property="og:title" content={t("site.casePage.pageTitle")} />
                <meta
                    property="og:description"
                    content={t("site.casePage.pageDescription")}
                />
                <meta
                    property="og:image"
                    content={require('@images/social-banners/main.jpg')}
                />
            </Head>

            <Header locale={pageProps.locale} menu={pageProps.menu}></Header>

            <div className="cases container mb-80px ph:mb-100px">
                <div className="container__inner">
                    <Breadcrumbs breadcrumbs={pageProps.breadcrumbs} />
                    <h1 className="mt-64px">{t("site.casePage.title")}</h1>
                    <div className="cases__welcome mt-48px">
                        <div className="cases__welcome-column cases__welcome-column--text" dangerouslySetInnerHTML={{
                            __html: pageProps.settings.find(
                                (el) => el.key === "cases_welcome"
                            )?.value,
                        }}
                        ></div>
                        <div className="cases__welcome-column cases__welcome-column--img">
                            <img src={casesPointsPicture} alt="Picture" />
                            {
                                t("case.caseDecor").map(({ id, title, text }) => {
                                    return <div className={`info-card info-card--${id} ${isLoaded ? 'animate' : ''}`} key={id}>
                                        <p className="info-card__title">{title}</p>
                                        <p className="info-card__text" dangerouslySetInnerHTML={{ __html: text }} />
                                    </div>
                                })
                            }
                        </div>
                    </div>

                    <div className="cases__content mt-48px">
                        <div className="cases__cards">
                            {
                                pageProps.cases.map((data) => {
                                    return <CaseBlock data={data} locale={pageProps.locale} key={data.id} />
                                })
                            }
                        </div>
                    </div>
                </div>

                <DecorContainer zIndex={2}>
                    <DecorBlob
                        typeNum={1}
                        width={1034.4}
                        opacity={1}
                        x={82}
                        y={-731}
                        animations={["pulse"]}
                        animDuration={8}
                        gsapMove={true}
                    />
                    <DecorBlob
                        typeNum={1}
                        width={1191.12}
                        rotate={-167}
                        opacity={0.3}
                        x={1150}
                        y={663}
                        animations={["pulse"]}
                        animDuration={8}
                        gsapMove={true}
                    />
                    <DecorBlob
                        typeNum={4}
                        width={1252.19}
                        blur={50}
                        rotate={120.609}
                        opacity={1}
                        x={1127}
                        y={438}
                        animations={["pulse"]}
                        animDuration={8}
                        gsapMove={true}
                    />

                    <DecorBlob
                        typeNum={4}
                        width={1168.19}
                        blur={150}
                        rotate={-49.21}
                        opacity={1}
                        x={195}
                        y={1500}
                    />
                    <DecorBlob
                        typeNum={4}
                        width={1168.19}
                        blur={150}
                        rotate={80}
                        opacity={1}
                        x={-984}
                        y={1233}
                    />
                </DecorContainer>
            </div>

            <Footer pageProps={pageProps}></Footer>
        </>
    );
}
